// Mirrors the backend BlockingMode enum (ResourceSlots/BlockingMode.cs) and the resources_slots.blocking_mode
// MySQL ENUM. String-valued on purpose: the wire value IS the member name (the backend serializes enums with
// JsonStringEnumConverter), so no numeric-to-string coercion is ever needed.
export enum BlockingMode {
    FullyBlocking = 'FullyBlocking',
    PartiallyBlocking = 'PartiallyBlocking'
}

export interface MaintenanceSlot {
    title: string
    description: string | null
    dayOfWeek: string
    start: string
    end: string
    validFrom: number | null
    validUntil: number | null
    blockingMode: BlockingMode
    reducedCapacity: number | null
}

export interface ResourceMaintenanceSlot {
    resourceId: string;
    slots: MaintenanceSlot[];
}


// Calendar-ready maintenance time span
export interface MaintenanceTimeSpan {
    resourceId: string
    title: string
    description: string | null
    startUtc: string
    endUtc: string
    blockingMode: BlockingMode
    reducedCapacity: number | null
}
